import React from "react";
import ActiveJobsMainComponent from "../components/ActiveJobs/ActiveJobsMainComponent";

const ActiveJobsPage = () => {
  return <ActiveJobsMainComponent />;
};

export default ActiveJobsPage;
